/* istanbul ignore file */
import React from 'react';

import { getAllFeed } from '@lumapps/groups/ducks/selectors';
import { useSelector } from '@lumapps/redux/react';

import {
    ContentNotificationAlertDialog as ContentNotificationAlertDialogComponent,
    ContentNotificationAlertDialogProps,
} from './ContentNotificationAlertDialog';

const ContentNotificationAlertDialogWrapper: React.FC<Omit<ContentNotificationAlertDialogProps, 'allFeedId'>> = (
    props,
) => {
    const allFeed = useSelector(getAllFeed);

    return <ContentNotificationAlertDialogComponent {...props} allFeedId={allFeed?.id} />;
};

ContentNotificationAlertDialogWrapper.displayName = 'ContentNotificationAlertDialog';

export { ContentNotificationAlertDialogWrapper as ContentNotificationAlertDialog };
